@if (hasCommunityExpiryMessage()) {
  <div
    class="header__alerts bg-danger bg-gradient px-2 py-1 text-white shadow-sm"
  >
    @if (!userBean().identificationURL) {
      <h6 class="header-alert-expire text-center text-white m-0">
        <span class="text-center">
          @if (
            userBean().communitySubtype === CommunitySubType.TRIAL &&
            userBean().communityExpirationDaysCount === 0
          ) {
            <span
              translate="WEB_COMMUNITY_EXPIRATION_DAYS_COUNTDOWN_TEST_0"
              [translateParams]="{
                community: userBean().communityName,
                time: userBean().communityExpireDate | date: 'HH:mm',
              }"
            ></span>
          }
          @if (
            userBean().communitySubtype === CommunitySubType.TRIAL &&
            userBean().communityExpirationDaysCount === 1
          ) {
            <span
              translate="WEB_COMMUNITY_EXPIRATION_DAYS_COUNTDOWN_TEST_1"
              [translateParams]="{ community: userBean().communityName }"
            ></span>
          }
          @if (
            userBean().communitySubtype === CommunitySubType.TRIAL &&
            userBean().communityExpirationDaysCount === 2
          ) {
            <span
              translate="WEB_COMMUNITY_EXPIRATION_DAYS_COUNTDOWN_TEST_2"
              [translateParams]="{
                community: userBean().communityName,
                days: '2',
              }"
            ></span>
          }
          @if (
            userBean().communitySubtype === CommunitySubType.TRIAL &&
            userBean().communityExpirationDaysCount > 2
          ) {
            <span
              translate="WEB_COMMUNITY_EXPIRATION_DAYS_COUNTDOWN_TEST_N"
              [translateParams]="{
                community: userBean().communityName,
                date:
                  userBean().communityExpireDate
                  | localizedDate: 'longDate' : locale(),
              }"
            ></span>
          }
          @if (
            userBean().communitySubtype === CommunitySubType.TRIAL &&
            userBean().communityPermission ===
              PermissionLevel.MODIFY_AND_DELETE &&
            userBean().billing &&
            navigation().route !== ROUTE_NAMES.BILLING
          ) {
            <span>
              <a
                [routerLink]="'/billing'"
                class="btn btn-xs btn-primary ms-2 border-0 text-white"
              >
                {{ 'WEB_ACTIONS_SUBSCRIBE' | translate }}
              </a>
            </span>
          }
        </span>
      </h6>
    }
    @if (userBean().identificationURL) {
      <h6 class="header-alert-expire text-center text-white m-0">
        <span class="text-center">
          {{ 'WEB_USER_SIGNATURE_IDENTIFICATION_MESSAGE' | translate }}
          <a
            [href]="userBean().identificationURL"
            target="_blank"
            rel="noopener"
            class="btn btn-xs btn-primary ms-2 border-0 text-white"
          >
            {{ 'WEB_USER_SIGNATURE_IDENTIFICATION_BUTTON' | translate }}
          </a>
        </span>
      </h6>
    }
  </div>
}
<header
  class="header d-flex align-items-center px-2 gap-2"
  [class.community-expiry-message]="hasCommunityExpiryMessage()"
>
  <div class="d-flex align-items-center justify-content-between w-100">
    <div class="d-flex align-items-center">
      <span
        appClickable
        class="d-block d-md-none fs-5 me-2"
        [class.text-body-secondary]="!navigation().open"
        [attr.aria-expanded]="navigation().open"
        [attr.aria-label]="
          (navigation().open ? 'WEB_ACTIONS_COLLAPSE' : 'WEB_ACTIONS_EXPAND')
            | translate
        "
        (click)="toggleNavigation()"
      >
        <i class="bi bi-list" aria-hidden="true"></i>
      </span>

      <div class="py-2">
        @if (userBean().communityLogoUrl) {
          <div
            class="header-logo"
            appClickable
            [attr.aria-label]="'WEB_HOME_AAA' | translate"
            (click)="backHome()"
            [style.background-image]="
              'url(' + userBean().communityLogoUrl + ')'
            "
          ></div>
        } @else if (!userBean().communityLogo) {
          <div
            class="header-logo"
            [class]="{
              'header-logo--finma':
                userBean().authenticationMethod ===
                AuthenticationMethod.FINMA_SSO,
              'header-logo--default':
                userBean().authenticationMethod !==
                AuthenticationMethod.FINMA_SSO,
            }"
            appClickable
            [attr.aria-label]="'WEB_HOME_AAA' | translate"
            (click)="backHome()"
          ></div>
        }
      </div>
    </div>

    @if (
      userBean().communityStatus !== 3 &&
      navigation().route !== ROUTE_NAMES.SEARCH &&
      navigation().route !== ROUTE_NAMES.FILE
    ) {
      <div class="search-widget">
        <form
          name="searchWidget"
          class="d-none d-md-block"
          (ngSubmit)="initialSearch()"
          novalidate
        >
          <div class="input-group" ngbDropdown placement="bottom-end">
            <label
              for="searchText"
              class="p-0"
              class="input-group-text border-end-0"
              [class.cursor-default]="!query()"
            >
              <i class="bi bi-search"></i>
            </label>
            <input
              type="text"
              id="searchText"
              name="searchText"
              class="form-control search-text"
              [ngModel]="query()"
              (keydown.enter)="initialSearch()"
              (input)="updateQuery(getInputValue($event))"
              maxlength="255"
              placeholder="{{ 'WEB_ACTIONS_SEARCH' | translate }}…"
              [attr.aria-label]="'WEB_ACTIONS_SEARCH' | translate"
            />
            <button
              type="button"
              class="btn btn-outline-secondary d-flex align-items-center text-body-secondary no-caret"
              [attr.aria-label]="'WEB_COMMUNITY_SEARCH_OPTIONS' | translate"
              ngbDropdownToggle
            >
              <i
                [ngbTooltip]="'WEB_COMMUNITY_SEARCH_OPTIONS' | translate"
                placement="bottom"
                container="body"
                class="bi bi-sliders2 fs-5"
                aria-hidden="true"
              ></i>
            </button>
            <ul
              ngbDropdownMenu
              class="dropdown-menu-end min-width-350 pt-0 z-index-10000"
            >
              @if (resourceScopeOptionContext(); as resourceScope) {
                <li class="p-3 pb-2">
                  <div class="form-check ps-0 text-light text-base">
                    <label
                      class="d-flex align-items-center mb-2"
                      [class.text-link]="!isSearchScopedByCurrentResource()"
                    >
                      <input
                        class="visually-hidden"
                        type="radio"
                        name="currentResourceRid"
                        [checked]="!isSearchScopedByCurrentResource()"
                        (click)="setIsSearchScopedByResource(false)"
                      />
                      <i
                        class="bi me-1"
                        [class]="{
                          'bi-radio-circle': isSearchScopedByCurrentResource(),
                          'bi-radio-circle-checked':
                            !isSearchScopedByCurrentResource(),
                        }"
                      ></i>
                      <span>
                        {{
                          'WEB_COMMUNITY_SEARCH_INSIDE_COMMUNITY' | translate
                        }}
                      </span>
                    </label>
                    <label
                      class="d-flex align-items-center"
                      [class.text-link]="isSearchScopedByCurrentResource()"
                    >
                      <input
                        class="visually-hidden"
                        type="radio"
                        name="currentResourceRid"
                        [checked]="isSearchScopedByCurrentResource()"
                        (click)="setIsSearchScopedByResource(true)"
                      />
                      <i
                        class="bi me-1"
                        [class]="{
                          'bi-radio-circle': !isSearchScopedByCurrentResource(),
                          'bi-radio-circle-checked':
                            isSearchScopedByCurrentResource(),
                        }"
                      ></i>
                      <span
                        [translateParams]="{
                          resourceName: resourceScope.displayName,
                        }"
                        translate="WEB_COMMUNITY_SEARCH_INSIDE_RESOURCE"
                      ></span>
                    </label>
                  </div>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
              }
              <li class="px-3 pt-3">
                <div
                  class="d-flex flex-column"
                  role="radiogroup"
                  aria-labelledby="search-filter-type-label"
                >
                  <span
                    id="search-filter-type-label"
                    class="text-body-secondary text-base mb-2"
                    translate="WEB_LIST_TYPE_LIST_RESOURCE_TYPE"
                  ></span>
                  <label
                    class="text-base pb-1 cursor-pointer"
                    [class]="{
                      'text-link': !params().resourceType,
                      'text-light': params().resourceType,
                    }"
                  >
                    <input
                      type="radio"
                      class="visually-hidden"
                      name="search-filter-type"
                      [checked]="!params().resourceType"
                      (click)="updateFilter({ resourceType: undefined })"
                    />
                    <i
                      class="bi me-1"
                      [class]="{
                        'bi-radio-circle': params().resourceType,
                        'bi-radio-circle-checked': !params().resourceType,
                      }"
                    ></i>
                    {{ 'WEB_FILTER_ALL' | translate }}
                  </label>
                  <label
                    class="text-base pt-1 pb-1 cursor-pointer"
                    [class]="{
                      'text-link': params().resourceType === ResourceType.FILE,
                      'text-light': params().resourceType !== ResourceType.FILE,
                    }"
                  >
                    <input
                      type="radio"
                      class="visually-hidden"
                      name="search-filter-type"
                      [checked]="params().resourceType === ResourceType.FILE"
                      (click)="
                        updateFilter({ resourceType: ResourceType.FILE })
                      "
                    />
                    <i
                      class="bi me-1"
                      [class]="{
                        'bi-radio-circle':
                          params().resourceType !== ResourceType.FILE,
                        'bi-radio-circle-checked':
                          params().resourceType === ResourceType.FILE,
                      }"
                    ></i>
                    {{ 'WEB_FILTER_FILE' | translate }}
                  </label>
                  @if (
                    userBean().communityProfileId !==
                    CommunityProfileType.SIGNING_ROOM
                  ) {
                    <label
                      class="text-base pt-1 pb-1 cursor-pointer"
                      [class]="{
                        'text-link':
                          params().resourceType === ResourceType.ROOM,
                        'text-light':
                          params().resourceType !== ResourceType.ROOM,
                      }"
                    >
                      <input
                        type="radio"
                        class="visually-hidden"
                        name="search-filter-type"
                        [checked]="params().resourceType === ResourceType.ROOM"
                        (click)="
                          updateFilter({ resourceType: ResourceType.ROOM })
                        "
                      />
                      <i
                        class="bi me-1"
                        [class]="{
                          'bi-radio-circle':
                            params().resourceType !== ResourceType.ROOM,
                          'bi-radio-circle-checked':
                            params().resourceType === ResourceType.ROOM,
                        }"
                      ></i>
                      {{ 'WEB_FILTER_ROOM' | translate }}
                    </label>
                  }
                  @if (
                    userBean().functions.events || userBean().functions.meetings
                  ) {
                    <label
                      class="text-base pt-1 pb-1 cursor-pointer"
                      [class]="{
                        'text-link':
                          params().resourceType === ResourceType.EVENT,
                        'text-light':
                          params().resourceType !== ResourceType.EVENT,
                      }"
                    >
                      <input
                        type="radio"
                        class="visually-hidden"
                        name="search-filter-type"
                        [checked]="params().resourceType === ResourceType.EVENT"
                        (click)="
                          updateFilter({ resourceType: ResourceType.EVENT })
                        "
                      />
                      <i
                        class="bi me-1"
                        [class]="{
                          'bi-radio-circle':
                            params().resourceType !== ResourceType.EVENT,
                          'bi-radio-circle-checked':
                            params().resourceType === ResourceType.EVENT,
                        }"
                      ></i>
                      {{
                        (userBean().functions.events &&
                        !userBean().functions.meetings
                          ? 'WEB_FILTER_EVENT'
                          : !userBean().functions.events &&
                              userBean().functions.meetings
                            ? 'WEB_FILTER_MEETING'
                            : 'WEB_FILTER_MEETING_EVENT'
                        ) | translate
                      }}
                    </label>
                  }
                  @if (
                    userBean().functions.discussions &&
                    userBean().communityProfileId !==
                      CommunityProfileType.SIGNING_ROOM
                  ) {
                    <label
                      class="text-base pt-1 pb-1 cursor-pointer"
                      [class]="{
                        'text-link':
                          params().resourceType === ResourceType.DISCUSSION,
                        'text-light':
                          params().resourceType !== ResourceType.DISCUSSION,
                      }"
                    >
                      <input
                        type="radio"
                        class="visually-hidden"
                        name="search-filter-type"
                        [checked]="
                          params().resourceType === ResourceType.DISCUSSION
                        "
                        (click)="
                          updateFilter({
                            resourceType: ResourceType.DISCUSSION,
                          })
                        "
                      />
                      <i
                        class="bi me-1"
                        [class]="{
                          'bi-radio-circle':
                            params().resourceType !== ResourceType.DISCUSSION,
                          'bi-radio-circle-checked':
                            params().resourceType === ResourceType.DISCUSSION,
                        }"
                      ></i>
                      {{ 'WEB_FILTER_DISCUSSION' | translate }}
                    </label>
                  }
                  @if (
                    userBean().communityProfileId !==
                    CommunityProfileType.SIGNING_ROOM
                  ) {
                    <label
                      class="text-base pt-1 pb-1 cursor-pointer"
                      [class]="{
                        'text-link':
                          params().resourceType === ResourceType.ACTIVITY,
                        'text-light':
                          params().resourceType !== ResourceType.ACTIVITY,
                      }"
                    >
                      <input
                        type="radio"
                        class="visually-hidden"
                        name="search-filter-type"
                        [checked]="
                          params().resourceType === ResourceType.ACTIVITY
                        "
                        (click)="
                          updateFilter({
                            resourceType: ResourceType.ACTIVITY,
                          })
                        "
                      />
                      <i
                        class="bi me-1"
                        [class]="{
                          'bi-radio-circle':
                            params().resourceType !== ResourceType.ACTIVITY,
                          'bi-radio-circle-checked':
                            params().resourceType === ResourceType.ACTIVITY,
                        }"
                      ></i>
                      {{ 'WEB_FILTER_TASK' | translate }}
                    </label>
                  }
                  @if (
                    userBean().communityProfileId !==
                      CommunityProfileType.SIGNING_ROOM &&
                    userBean().functions.votings
                  ) {
                    <label
                      class="text-base pt-1 pb-1 cursor-pointer"
                      [class]="{
                        'text-link':
                          params().resourceType === ResourceType.VOTING,
                        'text-light':
                          params().resourceType !== ResourceType.VOTING,
                      }"
                    >
                      <input
                        type="radio"
                        class="visually-hidden"
                        name="search-filter-type"
                        [checked]="
                          params().resourceType === ResourceType.VOTING
                        "
                        (click)="
                          updateFilter({ resourceType: ResourceType.VOTING })
                        "
                      />
                      <i
                        class="bi me-1"
                        [class]="{
                          'bi-radio-circle':
                            params().resourceType !== ResourceType.VOTING,
                          'bi-radio-circle-checked':
                            params().resourceType === ResourceType.VOTING,
                        }"
                      ></i>
                      {{ 'WEB_FILTER_VOTES' | translate }}
                    </label>
                  }
                  @if (userBean().functions.meetings) {
                    <label
                      class="text-base pt-1 pb-1 cursor-pointer"
                      [class]="{
                        'text-link':
                          params().resourceType === ResourceType.AGENDA_POINT,
                        'text-light':
                          params().resourceType !== ResourceType.AGENDA_POINT,
                      }"
                    >
                      <input
                        type="radio"
                        class="visually-hidden"
                        name="search-filter-type"
                        [checked]="
                          params().resourceType === ResourceType.AGENDA_POINT
                        "
                        (click)="
                          updateFilter({
                            resourceType: ResourceType.AGENDA_POINT,
                          })
                        "
                      />
                      <i
                        class="bi me-1"
                        [class]="{
                          'bi-radio-circle':
                            params().resourceType !== ResourceType.AGENDA_POINT,
                          'bi-radio-circle-checked':
                            params().resourceType === ResourceType.AGENDA_POINT,
                        }"
                      ></i>
                      {{ 'WEB_FILTER_AGENDA_POINTS' | translate }}
                    </label>
                  }
                  <label
                    class="text-base pt-1 pb-1 cursor-pointer"
                    [class]="{
                      'text-link': params().resourceType === ResourceType.USER,
                      'text-light': params().resourceType !== ResourceType.USER,
                    }"
                  >
                    <input
                      type="radio"
                      class="visually-hidden"
                      name="search-filter-type"
                      [checked]="params().resourceType === ResourceType.USER"
                      (click)="
                        updateFilter({ resourceType: ResourceType.USER })
                      "
                    />
                    <i
                      class="bi me-1"
                      [class]="{
                        'bi-radio-circle':
                          params().resourceType !== ResourceType.USER,
                        'bi-radio-circle-checked':
                          params().resourceType === ResourceType.USER,
                      }"
                    ></i>
                    {{ 'WEB_FILTER_USERS' | translate }}
                  </label>
                  <label
                    class="text-base pt-1 pb-1 cursor-pointer"
                    [class]="{
                      'text-link': params().resourceType === ResourceType.GROUP,
                      'text-light':
                        params().resourceType !== ResourceType.GROUP,
                    }"
                  >
                    <input
                      type="radio"
                      class="visually-hidden"
                      name="search-filter-type"
                      [checked]="params().resourceType === ResourceType.GROUP"
                      (click)="
                        updateFilter({ resourceType: ResourceType.GROUP })
                      "
                    />
                    <i
                      class="bi me-1"
                      [class]="{
                        'bi-radio-circle':
                          params().resourceType !== ResourceType.GROUP,
                        'bi-radio-circle-checked':
                          params().resourceType === ResourceType.GROUP,
                      }"
                    ></i>
                    {{ 'WEB_FILTER_GROUPS' | translate }}
                  </label>
                </div>
              </li>
              <li>
                <hr class="dropdown-divider" />
              </li>
              <li class="ps-3 pe-3 pb-3 pt-2">
                <div class="d-flex flex-column">
                  <span
                    id="search-filter-date-label"
                    class="text-body-secondary text-base mb-2"
                    translate="WEB_EVENT_DATE"
                  ></span>
                  @if (!params().isCustomDate) {
                    <select
                      class="form-select text-light text-base"
                      aria-labelledby="search-filter-date-label"
                      [ngModel]="params().period"
                      name="isCustomDate"
                      (change)="
                        updateFilter({
                          period: getSelectValue($event),
                        });
                        initialSearch(getSelectValue($event) === undefined)
                      "
                      [attr.aria-label]="'WEB_EVENT_DATE' | translate"
                    >
                      <option
                        selected
                        [ngValue]="null"
                        translate="WEB_REPORTING_FILTER_ANY_TIME"
                      ></option>
                      <option
                        [ngValue]="1"
                        translate="WEB_REPORTING_FILTER_1_DAY"
                      ></option>
                      <option
                        [ngValue]="7"
                        translate="WEB_REPORTING_FILTER_1_WEEK"
                      ></option>
                      <option
                        [ngValue]="31"
                        translate="WEB_REPORTING_FILTER_MONTH"
                      ></option>
                      <option
                        [ngValue]="365"
                        translate="WEB_REPORTING_FILTER_YEAR"
                      ></option>
                      <option
                        [ngValue]="undefined"
                        translate="WEB_REPORTING_FILTER_CUSTOM"
                      ></option>
                    </select>
                  }
                  @defer (when params().isCustomDate) {
                    <div
                      class="d-flex align-items-center gap-2"
                      [hidden]="!params().isCustomDate"
                    >
                      <div class="input-date-group d-flex flex-column p-0">
                        <div class="position-relative">
                          <label class="visually-hidden" for="search-from">
                            {{ 'WEB_EVENT_FROMDATE' | translate }}
                          </label>
                          <app-date-input
                            [inputId]="'search-from'"
                            [placeholder]="'WEB_EVENT_FROMDATE' | translate"
                            [maxDate]="maxDate()!"
                            [invalid]="!!fromModelRef.invalid"
                            [(ngModel)]="fromDateModel"
                            #fromModelRef="ngModel"
                            name="from"
                            (ngModelChange)="
                              updateFilter({ from: fromDateModel })
                            "
                          />
                        </div>
                      </div>
                      <div class="input-date-group d-flex flex-column p-0">
                        <div class="position-relative">
                          <label class="visually-hidden" for="search-to">
                            {{ 'WEB_EVENT_TODATE' | translate }}
                          </label>
                          <app-date-input
                            [inputId]="'search-to'"
                            [placeholder]="'WEB_EVENT_TODATE' | translate"
                            [maxDate]="maxDate()!"
                            [invalid]="!!toModelRef.invalid || isFromGtTo()"
                            [(ngModel)]="toDateModel"
                            #toModelRef="ngModel"
                            name="to"
                            (ngModelChange)="updateFilter({ to: toDateModel })"
                          />
                        </div>
                      </div>
                      <span
                        appClickable
                        [attr.aria-label]="'WEB_ACTIONS_CLEAR' | translate"
                        (click)="
                          updateFilter({ period: null, isCustomDate: false });
                          initDate()
                        "
                        class="bi bi-x fs-4 text-light d-flex"
                      ></span>
                    </div>
                  }
                </div>
                <div
                  [hidden]="!params().isCustomDate"
                  class="d-flex flex-column align-items-center mt-2"
                >
                  <span
                    [hidden]="
                      !(validDate().from === false || validDate().to === false)
                    "
                    class="text-small text-danger"
                    translate="WEB_FORMS_VALIDATION_DATE_INVALID"
                    [translateParams]="{ format: dateFormatter }"
                  ></span>
                  <span
                    [hidden]="!validDate().errorIntervalDate"
                    class="text-small text-danger"
                    translate="WEB_FORMS_VALIDATION_DATE_TO_BEFORE_FROM"
                  ></span>
                </div>
              </li>
            </ul>
          </div>
          <button type="submit" hidden></button>
        </form>
      </div>
    }

    <div
      class="d-flex align-items-center gap-3"
      [class.ms-auto]="navigation().route === ROUTE_NAMES.SEARCH"
    >
      @if (
        userBean().communityStatus !== 3 &&
        navigation().route !== ROUTE_NAMES.SEARCH
      ) {
        <a
          [routerLink]="'search'"
          (click)="initialSearch()"
          [attr.aria-label]="'WEB_ACTIONS_SEARCH' | translate"
          class="text-body-secondary d-block d-md-none"
        >
          <i class="bi bi-search fs-5 text-body-secondary"></i>
        </a>
      }

      <div class="d-flex align-items-center gap-3">
        @if (
          userBean().communityStatus !== 3 &&
          userBean().subtype !== UserSubType.ONE_TIME_GUEST &&
          userBean().communityProfileId !== CommunityProfileType.SIGNING_ROOM
        ) {
          <div class="alerts-widget position-relative">
            @defer {
              <app-alerts-widget />
            } @placeholder {
              <span class="fs-5 text-body-secondary bi bi-bell"></span>
            }
          </div>
        }
        @if (
          userBean().communityStatus !== 3 &&
          userBean().subtype !== UserSubType.ONE_TIME_GUEST &&
          userBean().communityProfileId !== CommunityProfileType.SIGNING_ROOM
        ) {
          <div class="favorites-widget position-relative">
            @defer {
              <app-favorites-widget />
            } @placeholder {
              <span class="bi fs-5 text-body-secondary bi-star"></span>
            }
          </div>
        }
      </div>

      <div
        #userDropdown="ngbDropdown"
        ngbDropdown
        autoClose="outside"
        (openChange)="selectLang = false"
      >
        <div
          class="header-user d-none d-md-flex align-items-center no-caret"
          appClickable
          data-testid="header-user-dropdown-toggle"
          ngbDropdownToggle
        >
          <div class="header-user-image">
            <app-profile-image
              [size]="'sm'"
              [userId]="userBean().userId"
              [subtype]="userBean().subtype"
              [shortName]="userBean().shortName"
              [userType]="2"
              [isImageDefined]="userBean().imageDefined"
            />
          </div>
          <div class="header-user-label" #headerUserLabel>
            <div class="title">
              <span class="user-title-name">
                {{ userBean().displayName }}
              </span>
              <div class="drop-icon">
                <i class="bi bi-chevron-down"></i>
              </div>
            </div>
            <div class="info">
              <span>{{ userBean().communityName }}</span>
            </div>
          </div>
          <span class="visually-hidden">
            {{ 'WEB_USER_MY_PROFILE' | translate }}
          </span>
        </div>
        <div ngbDropdownMenu class="dropdown-menu-end" role="menu">
          @if (userBean().communityStatus !== 3) {
            <a
              role="menuitem"
              ngbDropdownItem
              [routerLink]="['/users', userBean().userId]"
              (click)="userDropdown.close()"
              [hidden]="selectLang"
            >
              {{ 'WEB_USER_MY_PROFILE' | translate }}
            </a>
          }
          @if (personalRoomId(); as roomId) {
            <a
              role="menuitem"
              ngbDropdownItem
              [routerLink]="['/rooms', roomId]"
              (click)="userDropdown.close()"
              [hidden]="selectLang"
            >
              {{ 'WEB_ROOM_TYPE_2' | translate }}
            </a>
          }
          @if (
            userBean().subtype === UserSubType.MEMBER &&
            userBean().communityStatus !== 3 &&
            userBean().authenticationMethod !==
              AuthenticationMethod.FINMA_SSO &&
            userBean().authenticationMethod !==
              AuthenticationMethod.AZURE_AD_SSO
          ) {
            <div
              role="menuitem"
              appClickable
              ngbDropdownItem
              [hidden]="selectLang"
              (click)="changePassword(userBean().userId!); userDropdown.close()"
            >
              {{ 'WEB_USER_PASSWORD_CHANGE' | translate }}
            </div>
          }
          @if (
            !userBean().communityPermission ||
            userBean().communityPermission < 5
          ) {
            <div
              role="menuitem"
              appClickable
              ngbDropdownItem
              [hidden]="selectLang"
              (click)="userSupport(); userDropdown.close()"
            >
              {{ 'WEB_ACTIONS_CONTACT_COMMUNITY_MANAGER' | translate }}
            </div>
          }
          @if (
            !userBean().communityPermission ||
            userBean().communityPermission < 5
          ) {
            <hr class="dropdown-divider" [hidden]="selectLang" />
          }
          <div
            role="menuitem"
            appClickable
            ngbDropdownItem
            [hidden]="selectLang"
            (click)="selectLang = true"
            class="d-flex align-items-center"
          >
            <span class="me-1">
              {{ locale() | localeKey | translate }}
            </span>
            <i class="bi bi-chevron-right"></i>
          </div>
          <hr class="dropdown-divider" [hidden]="selectLang" />
          <div
            role="menuitem"
            appClickable
            ngbDropdownItem
            [hidden]="selectLang"
            (click)="logout(); userDropdown.close()"
          >
            {{ 'WEB_ACTIONS_SIGN_OUT' | translate }}
          </div>
          <div
            role="menuitem"
            appClickable
            ngbDropdownItem
            [hidden]="!selectLang"
            (click)="selectLang = false"
            class="d-flex align-items-center"
          >
            <i class="bi bi-chevron-left me-1"></i>
            <span>{{ 'WEB_ACTIONS_BACK' | translate }}</span>
          </div>
          <hr class="dropdown-divider" [hidden]="!selectLang" />
          @for (language of languages(); track language) {
            <div
              role="menuitemradio"
              appClickable
              ngbDropdownItem
              [hidden]="!selectLang"
              [class.disabled]="language === locale()"
              (click)="
                selectLang = false; setLocale(language); userDropdown.close()
              "
              class="d-flex align-items-center"
              [attr.aria-checked]="language === locale()"
            >
              <span class="me-1">
                {{ language | localeKey | translate }}
              </span>
              <i
                [hidden]="language !== locale()"
                class="bi bi-check-circle-fill-empty"
              ></i>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="d-block d-md-none">
      <div
        ngbDropdown
        appDropdownSheet
        #userDropdownMobile="ngbDropdown"
        [hidden]="selectLang"
      >
        <span
          appClickable
          class="no-caret"
          ngbDropdownToggle
          (click)="toggleNavigation(true)"
        >
          @if (userBean()) {
            <app-profile-image
              [userId]="userBean().userId"
              [size]="'sm'"
              [subtype]="userBean().subtype"
              [shortName]="userBean().shortName"
              [userType]="2"
              [isImageDefined]="userBean().imageDefined"
            />
          }
          <span class="visually-hidden">
            {{ 'WEB_USER_MY_PROFILE' | translate }}
          </span>
        </span>
        <div ngbDropdownMenu role="menu">
          <a
            role="menuitem"
            ngbDropdownItem
            [routerLink]="['/users', userBean().userId]"
          >
            {{ 'WEB_USER_MY_PROFILE' | translate }}
          </a>
          @if (personalRoomId(); as roomId) {
            <a
              role="menuitem"
              ngbDropdownItem
              [routerLink]="['/rooms', roomId]"
            >
              {{ 'WEB_ROOM_TYPE_2' | translate }}
            </a>
          }
          @if (userBean().subtype !== UserSubType.ONE_TIME_GUEST) {
            <div
              role="menuitem"
              appClickable
              ngbDropdownItem
              (click)="changePassword(userBean().userId!)"
            >
              {{ 'WEB_USER_PASSWORD_CHANGE' | translate }}
            </div>
          }
          @if (
            !userBean().communityPermission ||
            userBean().communityPermission < 5
          ) {
            <div
              role="menuitem"
              appClickable
              ngbDropdownItem
              (click)="userSupport()"
            >
              {{ 'WEB_ACTIONS_CONTACT_COMMUNITY_MANAGER' | translate }}
            </div>
          }
          <div
            role="menuitem"
            appClickable
            ngbDropdownItem
            [hidden]="selectLang"
            (click)="openDropdownLanguages(); selectLang = true"
            class="d-flex align-items-center"
          >
            {{ 'WEB_ACTIONS_CHANGE_LANGUAGE' | translate }}
            <i class="bi bi-chevron-right"></i>
          </div>
          <div role="menuitem" appClickable ngbDropdownItem (click)="logout()">
            {{ 'WEB_ACTIONS_SIGN_OUT' | translate }}
          </div>
          <div role="menuitem" appClickable ngbDropdownItem class="d-md-none">
            {{ 'WEB_ACTIONS_CANCEL' | translate }}
          </div>
        </div>
      </div>

      <div
        #languagesDropdown="ngbDropdown"
        ngbDropdown
        appDropdownSheet
        [hidden]="!selectLang"
      >
        <span
          appClickable
          class="text-body-secondary no-caret"
          [attr.aria-label]="'WEB_ACTIONS_CHANGE_LANGUAGE' | translate"
          ngbDropdownToggle
        >
          <i
            class="bi bi-translate fs-3 text-body-secondary"
            aria-hidden="true"
          ></i>
        </span>
        <ul ngbDropdownMenu class="dropdown-menu" role="menu">
          @for (language of languages(); track language) {
            <li
              role="menuitemradio"
              appClickable
              ngbDropdownItem
              [class.disabled]="language === locale()"
              (click)="selectLang = false; setLocale(language)"
              class="d-flex align-items-center"
              [attr.aria-checked]="language === locale()"
            >
              {{ language | localeKey | translate }}
              <i
                [hidden]="language !== locale()"
                class="bi bi-check-circle-fill-empty"
              ></i>
            </li>
          }
          <li role="menuitem" appClickable ngbDropdownItem>
            {{ 'WEB_ACTIONS_CANCEL' | translate }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
